import React, { useEffect, useRef, useState } from 'react'
import html2pdf from 'html2pdf.js';
import moment from 'moment';
import axios from 'axios';
import { useSearchParams } from 'react-router-dom';

const CrewReservationchartPrint = () => {
    const [printData, setPrintData] = useState({})
    const [searchParams] = useSearchParams()

    const componentRef = useRef();
    const generatePDF = () => {
        const element = componentRef.current;
        const opt = {
            margin: 10,
            filename: 'RESERVATION_CHART.pdf',
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 1 },
            jsPDF: { unit: 'mm', format: 'a4', orientation: 'landscape' }
        };

        html2pdf().from(element).set(opt).save().then(() => {

        });
    };

    useEffect(() => {
        if ((searchParams.get('JourneyDate') && searchParams.get('TripID')) && (searchParams.get('OTP') && searchParams.get('MobileNo')))
            axios({
                method: 'GET',
                url: `http://kasrtcrestapi.mavenconnect.tech/api/OtherData?JourneyDate=${searchParams.get('JourneyDate')}&TripID=${searchParams.get('TripID')}&OTP=${searchParams.get('OTP')}&MobileNo=${searchParams.get('MobileNo')}`,
                headers: {
                    Accept: "application/json",
                    Token: 'AmxtH9pkXM',
                },
            }).then((res) => {
                if (res.status === 200 && res.data.status) {
                    let data = res?.data?.Data
                    let otherData = data?.Table1 || []
                    let otherDataTotal = {
                        ResFee: 0,
                        InsuranceFee: 0,
                        BridgeFee: 0,
                        UserFee: 0,
                        EntryFee: 0,
                        TollFee: 0,
                        GST: 0,
                        roundAmt: data.Table9?.[0]?.TotalRoundOff || 0,
                        EndFare: 0,
                    }
                    otherData?.forEach((val) => {
                        otherDataTotal = {
                            ...otherDataTotal,
                            ResFee: Number(otherDataTotal.ResFee) + Number(val.ResFee),
                            InsuranceFee: Number(otherDataTotal.InsuranceFee) + Number(val.InsuranceFee),
                            BridgeFee: Number(otherDataTotal.BridgeFee) + Number(val.BridgeFee),
                            UserFee: Number(otherDataTotal.UserFee) + Number(val.UserFee),
                            EntryFee: Number(otherDataTotal.EntryFee) + Number(val.EntryFee),
                            TollFee: Number(otherDataTotal.TollFee) + Number(val.TollFee),
                            GST: Number(otherDataTotal.GST) + Number(val.GST),
                            EndFare: Number(otherDataTotal.EndFare) + Number(val.EndFare),
                        }
                    })
                    setPrintData({ ...data, otherData: [{ ...otherDataTotal, EndFare: Number(otherDataTotal?.EndFare) + Number(otherDataTotal?.roundAmt) }] })
                }
            })
    }, [searchParams]);
    useEffect(() => {
        let inactivityTimeout;

        if (Object.keys(printData)?.length > 0) {
            inactivityTimeout = setTimeout(() => {
                generatePDF();
            }, 1000);
        }
        return () => {
            clearTimeout(inactivityTimeout);
        };
    }, [printData]);
    const column1 = [
        { name: 'Trip Code', value: 'TripCode' },
        { name: 'Class', value: 'Class' },
        { name: 'Division', value: 'Division' },
        { name: 'Depot.', value: 'DepoName' },
        { name: 'Schedule No.', value: 'ScheduleNo' },
    ]
    const column2 = [
        { name: 'Origin', value: 'FromCity' },
        { name: 'Start Point', value: 'PickupName' },
        { name: 'Destination', value: 'ToCity' },
        { name: 'End Point', value: 'DropoffName' },
        { name: 'Via Place', value: 'ViaPlaces' },
    ]
    const column3 = [
        { name: 'Date of Journey', value: 'JourneyDate' },
        { name: 'Departure Time', value: 'DepTime' },
        { name: 'Vehicle No.', value: 'VehicleNo' },
        { name: 'Crew No.', value: 'CrewNo' },
        { name: 'Trip Sheet No.', value: 'TripSheetID' },
    ]
    //Table1
    const tableHeader1 = [
        { name: `Seat\nNo.`, field: "SeatNo", style: { minWidth: '10.5mm', maxWidth: '10.5mm', textAlign: 'left' } },
        { name: 'PNR', field: "PNR", style: { minWidth: '23.81mm', maxWidth: '23.81mm', textAlign: 'left' } },
        { name: 'Name', field: "Passenger", style: { minWidth: '23.81mm', maxWidth: '23.81mm', textAlign: 'left' } },
        { name: 'Ticket No.', field: "TicketNo", style: { minWidth: '23.81mm', maxWidth: '23.81mm', textAlign: 'left' } },
        { name: 'A/C', field: "AorC", style: { minWidth: '11.90mm', maxWidth: '11.90mm', textAlign: 'left' } },
        { name: 'Gender', field: "Gender", style: { minWidth: '11.90mm', maxWidth: '11.90mm', textAlign: 'left' } },
        { name: 'Category', field: "Ref", style: { minWidth: '23.81mm', maxWidth: '23.81mm', textAlign: 'left' } },
        { name: 'From', field: "FromCityShortName", style: { minWidth: '11.87mm', maxWidth: '12.87mm', textAlign: 'left' } },
        { name: 'To', field: "ToCityShortName", style: { minWidth: '11.87mm', maxWidth: '11.87mm', textAlign: 'left' } },
        { name: 'Pickup Point', field: "PickupLocation", style: { minWidth: '23.81mm', maxWidth: '23.81mm', textAlign: 'left' } },
        { name: 'Basic Fare', field: "BasicFare", style: { minWidth: '15.87mm', maxWidth: '16.87mm', textAlign: 'right' } },
        { name: 'Levies', field: "Levies", style: { minWidth: '15.87mm', maxWidth: '15.87mm', textAlign: 'right' } },
        { name: 'GST', field: "GST", style: { minWidth: '15.87mm', maxWidth: '15.87mm', textAlign: 'right' } },
        { name: 'End Fare', field: "EndFare", style: { minWidth: '15.87mm', maxWidth: '15.87mm', textAlign: 'right' } },
        { name: 'Phone No.', field: "PhoneNO", style: { minWidth: '23.81mm', maxWidth: '23.81mm', textAlign: 'left' } }
    ];
    //Table1
    const tableHeader2 = [
        { name: `Res. Fee`, field: "ResFee", style: { minWidth: '26mm', maxWidth: '26mm', textAlign: 'right' } },
        { name: 'ARF', field: "InsuranceFee", style: { minWidth: '26mm', maxWidth: '26mm', textAlign: 'right' } },
        { name: 'BridgeFee', field: "BridgeFee", style: { minWidth: '26mm', maxWidth: '26mm', textAlign: 'right' } },
        { name: 'User Fee', field: "UserFee", style: { minWidth: '26mm', maxWidth: '26mm', textAlign: 'right' } },
        { name: 'Entry Fee', field: "EntryFee", style: { minWidth: '26mm', maxWidth: '26mm', textAlign: 'right' } },
        { name: 'TollFee', field: "TollFee", style: { minWidth: '26mm', maxWidth: '26mm', textAlign: 'right' } },
        { name: 'GST', field: "GST", style: { minWidth: '26mm', maxWidth: '26mm', textAlign: 'right' } },
        { name: 'Round Of Fee', field: "roundAmt", style: { minWidth: '41.1mm', maxWidth: '41.1mm', textAlign: 'right' } },
        { name: 'Grand Total (Round Off)', field: "EndFare", style: { minWidth: '41.1mm', maxWidth: '41.1mm', textAlign: 'right' } },
    ];

    //Table3
    const tableHeader3 = [
        { name: `From Place`, field: "FromCityName", style: { minWidth: '85mm', maxWidth: '85mm', textAlign: 'left' } },
        { name: 'To Place', field: "ToCityName", style: { minWidth: '85mm', maxWidth: '85mm', textAlign: 'left' } },
        { name: 'Adult', field: "sumAdultSeatCount", style: { minWidth: '47mm', maxWidth: '47mm', textAlign: 'right' } },
        { name: 'Child', field: "sumChildSeatCount", style: { minWidth: '47mm', maxWidth: '47mm', textAlign: 'right' } },
    ];

    //Table8
    const tableHeader4 = [
        { name: `Quota Type`, field: "QoutaType", style: { minWidth: '61.33mm', maxWidth: '61.33mm', textAlign: 'left' } },
        { name: `From Place`, field: "FromCityName", style: { minWidth: '61.33mm', maxWidth: '61.33mm', textAlign: 'left' } },
        { name: 'To Place', field: "ToCityName", style: { minWidth: '61.33mm', maxWidth: '61.33mm', textAlign: 'left' } },
        { name: 'Available From Seat No.', field: "FromSeatNo", style: { minWidth: '40mm', maxWidth: '40mm', textAlign: 'right' } },
        { name: 'Available To Seat No.', field: "ToSeatNo", style: { minWidth: '40mm', maxWidth: '40mm', textAlign: 'right' } },
    ];
    //Table6
    const tableHeader5 = [
        { name: `From Service`, field: "OldService", style: { minWidth: '29.00mm', maxWidth: '29.00mm', textAlign: 'left' } },
        { name: `To Service`, field: "NewService", style: { minWidth: '29.00mm', maxWidth: '29.00mm', textAlign: 'left' } },
        { name: `From Place`, field: "NewFromCity", style: { minWidth: '29.00mm', maxWidth: '29.00mm', textAlign: 'left' } },
        { name: 'To Place', field: "NewToCity", style: { minWidth: '29.00mm', maxWidth: '29.00mm', textAlign: 'left' } },
        { name: 'From Class Type', field: "FromClass", style: { minWidth: '29.00mm', maxWidth: '29.00mm', textAlign: 'left' } },
        { name: 'To Class Type', field: "ToClass", style: { minWidth: '29.00mm', maxWidth: '29.00mm', textAlign: 'left' } },
        { name: 'From Seat Details', field: "SeatNosOld", style: { minWidth: '30.65mm', maxWidth: '30.65mm', textAlign: 'left' } },
        { name: 'To Seat Details', field: "SeatNosNew", style: { minWidth: '29.33mm', maxWidth: '29.33mm', textAlign: 'left' } },
        { name: 'Transferred Date', field: "EntryDate", style: { minWidth: '29.33mm', maxWidth: '29.33mm', textAlign: 'right' } },
    ];

    //Table4
    const tableHeader6 = [
        { name: `Place Name`, field: "CityName", style: { minWidth: '85mm', maxWidth: '85mm', textAlign: 'left' } },
        { name: 'Boarding / Dropping Point', field: "PickupName", style: { minWidth: '85mm', maxWidth: '85mm', textAlign: 'left' } },
        { name: 'Departure Time(HH(24)mm)', field: "PickupTime", style: { minWidth: '47mm', maxWidth: '47mm', textAlign: 'left' } },
        { name: 'Total Passenger Number', field: "NoPassenger", style: { minWidth: '47mm', maxWidth: '47mm', textAlign: 'right' } },
    ];

    //Table2
    const tableHeader7 = [
        { name: `No. of Seats`, field: "ConssionSeatNo", style: { minWidth: '88mm', maxWidth: '88mm', textAlign: 'left' } },
        { name: 'Concession Name', field: "ConcessionTypeName", style: { minWidth: '88mm', maxWidth: '88mm', textAlign: 'left' } },
        { name: 'Concession Amount', field: "ConcessionAmount", style: { minWidth: '88mm', maxWidth: '88mm', textAlign: 'right' } },
    ];

    const tableComponent = (headerCol = [], data = []) => {
        return (
            <table style={{
                borderCollapse: 'collapse',
            }}>
                <thead>
                    <tr style={{
                        backgroundColor: '#E5F3FF',
                        border: "0.13mm solid #dddddd"
                    }}>
                        {headerCol.map((val) => (
                            <th style={{
                                ...val?.style,
                                fontSize: "3.17mm",
                                fontWeight: '500',
                                padding: '1mm 2.1mm',
                                height: '11.6mm',
                                boxSizing: 'border-box'
                            }}>
                                {val.name}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {data?.length > 0 ? data.map((val) => (
                        <tr style={{
                            border: "0.13mm solid #dddddd"
                        }}>
                            {headerCol.map((obj) => (
                                <td style={{
                                    ...obj?.style,
                                    fontSize: "3.17mm",
                                    fontWeight: '500',
                                    padding: '1mm 2.1mm',
                                    height: '11.6mm',
                                    boxSizing: 'border-box'
                                }}>
                                    {val[obj.field]}
                                </td>
                            ))}
                        </tr>
                    )) :
                        <tr style={{
                            border: "0.13mm solid #dddddd"
                        }}>
                            <td colSpan={headerCol?.length} style={{
                                fontSize: "3.17mm",
                                fontWeight: '500',
                                padding: '1mm 2.1mm',
                                height: '11.6mm',
                                boxSizing: 'border-box'
                            }}>

                            </td>
                        </tr>
                    }
                </tbody>
            </table>
        )
    }
    return (
        <>
            <div style={{ display: "none" }}>
                <div ref={componentRef} style={{
                    border: '1px solid #000000',
                    padding: '4.2mm',
                }}>
                    <div style={{ minHeight: '16.4mm', backgroundColor: '#B2DAFF', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                        <div
                            style={{
                                fontWeight: '700',
                                lineHeight: '4.2mm',
                                fontSize: '3.7mm',
                                color: '#000'
                            }}
                        >KARNATAKA STATE ROAD TRANSPORT CORPORATION</div>
                        <div style={{
                            fontWeight: '700',
                            lineHeight: '4.2mm',
                            fontSize: '3.7mm',
                            color: '#000'
                        }}>RESERVATION CHART</div>
                    </div>
                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        paddingTop: '2.1mm'

                    }}>
                        <p style={{
                            color: '#202020',
                            fontSize: '3.17mm',
                            fontWeight: '600'
                        }}>Conductor Phone No. : {`${printData?.Table10?.[0]?.MobileNo || ''}`}</p>
                        <p style={{
                            color: '#202020',
                            fontSize: '3.17mm',
                            fontWeight: '600'
                        }}>Print Date Time:{moment(new Date()).format('DD-MMM-YYYY HH:mm:ss')}</p>
                    </div>
                    <div style={{
                        display: 'flex',
                        paddingTop: '2.1mm',
                    }}>
                        <div style={{ width: '33%', borderRight: '0.26mm solid #004F9E', }}>
                            {column1.map((val) => (
                                <div style={{ display: 'flex', minHeight: '7.40mm', alignItems: 'center', padding: '0mm 4.2mm 0mm 0mm' }}>
                                    <div style={{
                                        width: '50%',
                                        display: 'flex',
                                        justifyContent: 'space-between'
                                    }}>
                                        <p style={{
                                            fontSize: '3.17mm',
                                            fontWeight: '500',
                                            color: '#202020'

                                        }}>{val?.name}</p>
                                        <p style={{
                                            fontSize: '3.17mm',
                                            fontWeight: '500',
                                            color: '#202020'

                                        }}>:</p>
                                    </div>
                                    <div style={{
                                        width: '50%',
                                    }}>
                                        <p style={{
                                            fontSize: '3.17mm',
                                            fontWeight: '500',
                                            color: '#202020'
                                        }}>{printData?.Table?.[0]?.[val?.value] || ''}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div style={{ width: '33%', borderRight: '0.26mm solid #004F9E', }}>
                            {column2.map((val) => (
                                <div style={{ display: 'flex', minHeight: '7.40mm', alignItems: 'center', padding: '0mm 4.2mm' }}>
                                    <div style={{
                                        width: '50%',
                                        display: 'flex',
                                        justifyContent: 'space-between'
                                    }}>
                                        <p style={{
                                            fontSize: '3.17mm',
                                            fontWeight: '500',
                                            color: '#202020'

                                        }}>{val?.name}</p>
                                        <p style={{
                                            fontSize: '3.17mm',
                                            fontWeight: '500',
                                            color: '#202020'

                                        }}>:</p>
                                    </div>
                                    <div style={{
                                        width: '50%',
                                    }}>
                                        <p style={{
                                            fontSize: '3.17mm',
                                            fontWeight: '500',
                                            color: '#202020'
                                        }}>{printData?.Table?.[0]?.[val?.value] || ''}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div style={{ width: '33%', }}>
                            {column3.map((val) => (
                                <div style={{ display: 'flex', minHeight: '7.40mm', alignItems: 'center', padding: '0mm 0mm 0mm 4.2mm' }}>
                                    <div style={{
                                        width: '50%',
                                        display: 'flex',
                                        justifyContent: 'space-between'
                                    }}>
                                        <p style={{
                                            fontSize: '3.17mm',
                                            fontWeight: '500',
                                            color: '#202020'

                                        }}>{val?.name}</p>
                                        <p style={{
                                            fontSize: '3.17mm',
                                            fontWeight: '500',
                                            color: '#202020'

                                        }}>:</p>
                                    </div>
                                    <div style={{
                                        width: '50%',
                                    }}>
                                        <p style={{
                                            fontSize: '3.17mm',
                                            fontWeight: '500',
                                            color: '#202020'
                                        }}>{printData?.Table?.[0]?.[val?.value] || ''}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div style={{
                        paddingTop: '2.1mm',
                    }}>
                        {tableComponent(tableHeader1, printData?.Table1?.length > 0 ? printData?.Table1 : [])}

                    </div>
                    <div style={{
                        paddingTop: '2.1mm',
                    }}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <p style={{ margin: '0', fontSize: '4.23mm', fontWeight: "600", color: '#004F9E' }}>OTHERS</p>
                            <div style={{ flex: 1, margin: '0px 2.6mm', borderBottom: '0.26mm solid #004F9E' }}></div>
                        </div>
                    </div>
                    <div style={{
                        paddingTop: '2.1mm',
                    }}>
                        {tableComponent(tableHeader2, printData?.otherData?.length > 0 ? printData?.otherData : [])}
                    </div>
                    <div style={{
                        paddingTop: '2.1mm',
                    }}>
                        <div style={{ color: '#202020', fontSize: '3.17mm', fontWeight: '500' }}>Seats Vacant&nbsp;:&nbsp; {`[${printData?.Table5?.[0]?.EmptySeatsNos || ''}]`}</div>
                    </div>
                    <div style={{
                        paddingTop: '2.1mm',
                    }}>
                        <div style={{ color: '#202020', fontSize: '3.17mm', fontWeight: '500' }}>SINGLE LADY BOOKED SEAT DETAILS &nbsp;:&nbsp;{`${printData?.Table7?.[0]?.SingleLadySeats || ''}`}</div>
                    </div>
                    <div style={{
                        paddingTop: '2.1mm',
                    }}>
                        <div style={{ color: '#202020', fontSize: '3.17mm', fontWeight: '500' }}>Enroute Refreshment Stops&nbsp;:&nbsp;{`${printData?.Table?.[0]?.EnrouteRefreshment || ''}`}</div>
                    </div>
                    <div style={{
                        paddingTop: '2.1mm',
                    }}>
                        {tableComponent(tableHeader3, printData?.Table3?.length > 0 ? printData?.Table3 : [])}

                    </div>
                    <div style={{
                        paddingTop: '2.1mm',
                    }}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <p style={{ margin: '0', fontSize: '4.23mm', fontWeight: "600", color: '#004F9E' }}>AVAILABLE ROUTE QUOTA SEATS</p>
                            <div style={{ flex: 1, margin: '0px 2.6mm', borderBottom: '0.26mm solid #004F9E' }}></div>
                        </div>
                    </div>
                    <div style={{
                        paddingTop: '2.1mm',
                    }}>
                        {tableComponent(tableHeader4, printData?.Table8?.length > 0 ? printData?.Table8 : [])}

                    </div>
                    <div style={{
                        paddingTop: '2.1mm',
                    }}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <p style={{ margin: '0', fontSize: '4.23mm', fontWeight: "600", color: '#004F9E' }}>TRANSFER SEATS DETAILS</p>
                            <div style={{ flex: 1, margin: '0px 2.6mm', borderBottom: '0.26mm solid #004F9E' }}></div>
                        </div>
                    </div>
                    <div style={{
                        paddingTop: '2.1mm',
                    }}>
                        {tableComponent(tableHeader5, printData?.Table6?.length > 0 ? printData?.Table6 : [])}

                    </div>

                    <div style={{
                        paddingTop: '2.1mm',
                    }}>
                        {tableComponent(tableHeader6, printData?.Table4?.length > 0 ? printData?.Table4 : [])}

                    </div>
                    <div style={{
                        paddingTop: '2.1mm',
                    }}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <p style={{ margin: '0', fontSize: '4.23mm', fontWeight: "600", color: '#004F9E' }}>Concessions</p>
                            <div style={{ flex: 1, margin: '0px 2.6mm', borderBottom: '0.26mm solid #004F9E' }}></div>
                        </div>
                    </div>
                    <div style={{
                        paddingTop: '2.1mm',
                    }}>
                        {tableComponent(tableHeader7, printData?.Table2?.length > 0 ? printData?.Table2 : [])}

                    </div>
                </div>
            </div>

        </>
    )
}

export default CrewReservationchartPrint